import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Drawer as MUIDrawer, List, ListItem, IconButton } from '@material-ui/core';
import { Menu } from '@material-ui/icons';
import { useHistory } from 'react-router-dom';
import shortid from 'shortid';
import { setSearchQuery } from '../../redux/modules/search';
import { PAGES } from './data';
import useStyles from './Drawer.styles';

const Drawer = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (toggle) => {
    setDrawerOpen(toggle);
  };

  const handleOnClick = (path) => {
    dispatch(setSearchQuery(''));
    history.push(path);
  };

  return (
    <div className={classes.root}>
      <IconButton onClick={() => toggleDrawer(true)}>
        <Menu className={classes.menuIcon} />
      </IconButton>
      <MUIDrawer anchor="right" open={drawerOpen} onClose={() => toggleDrawer(false)}>
        <List className={classes.list}>
          {PAGES.map((page) => (
            <ListItem className={classes.listItem} key={shortid()} button onClick={() => handleOnClick(page.path)}>
              {page.label}
            </ListItem>
          ))}
        </List>
      </MUIDrawer>
    </div>
  );
};

export default Drawer;
